import React from "react";
import "./BootcampStudyMode.css";

import {
  Clock3,
  MonitorPlay,
  RefreshCw,
  Sparkles,
  Users,
  MessageSquareText,
} from "lucide-react";

import classroomImage from "../../images/Landscape/classRoomLive2.JPG";
import chartBg from "../../images/Chart 4.webp";

const studyRows = [
  {
    id: "review-time",
    icon: RefreshCw,
    label: "Trader Review Time",
    value: "24 hours",
  },
  {
    id: "weekly-hours",
    icon: Clock3,
    label: "Hours",
    value: "10–20 hours a week",
  },
  {
    id: "mentor-sessions",
    icon: Users,
    label: "1-to-1 Mentor Sessions",
    value: "4 per month",
  },
  {
    id: "live-facilitation",
    icon: MonitorPlay,
    label: "Live Facilitation",
    value: "Choose Wednesday or Saturday online",
  },
  {
    id: "support",
    icon: MessageSquareText,
    label: "Support",
    value: "Professional feedback on trade submissions + live webinars",
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
  "green",
];

const rowTrends = ["gold", "green", "green", "gold", "green"];

function StudyDetailCard({ row, index }) {
  const Icon = row.icon;

  return (
    <li
      className="trpc-studyMode__detailCard"
      data-trend={rowTrends[index] || "green"}
    >
      <span className="trpc-studyMode__detailIcon" aria-hidden="true">
        <Icon size={18} />
      </span>

      <span className="trpc-studyMode__detailCopy">
        <span className="trpc-studyMode__detailLabel">{row.label}</span>
        <strong className="trpc-studyMode__detailValue">{row.value}</strong>
      </span>
    </li>
  );
}

function BootcampStudyMode() {
  return (
    <section
      className="trpc-studyMode"
      aria-labelledby="trpc-studyMode-title"
    >
      <div className="trpc-studyMode__shell">
        <article className="trpc-studyMode__frame">
          <img
            className="trpc-studyMode__chartBg"
            src={chartBg}
            alt=""
            decoding="async"
            loading="lazy"
            aria-hidden="true"
          />

          <div className="trpc-studyMode__panelShade" aria-hidden="true" />

          <div className="trpc-studyMode__marketLayer" aria-hidden="true">
            <span className="trpc-studyMode__priceLine" />

            <div className="trpc-studyMode__candleGroup">
              {marketCandles.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-studyMode__candle"
                  data-trend={trend}
                />
              ))}
            </div>
          </div>

          <div className="trpc-studyMode__header">
            <span className="trpc-studyMode__kicker">
              <Sparkles size={16} aria-hidden="true" />
              Learn seriously. Trade consistently.
            </span>

            <h2 id="trpc-studyMode-title" className="trpc-studyMode__title">
              A serious trading pathway, delivered part-time
            </h2>

            <p className="trpc-studyMode__subtitle">
              A structured online pathway for serious beginners, working
              professionals and aspiring traders who want to build real skill
              without stepping away from everyday life.
            </p>
          </div>

          <div className="trpc-studyMode__panel">
            <div className="trpc-studyMode__mediaFrame">
              <img
                className="trpc-studyMode__mediaImage"
                src={classroomImage}
                alt="Live online trading classroom session"
                decoding="async"
                loading="lazy"
              />

              <div className="trpc-studyMode__mediaOverlay" aria-hidden="true" />

              <div className="trpc-studyMode__mediaBadge">
                <span>Flexible live sessions</span>
                <strong>Choose Wednesday or Saturday online</strong>
              </div>
            </div>

            <div className="trpc-studyMode__tableCard">
              <div className="trpc-studyMode__tableHead">
                <div className="trpc-studyMode__tableHeadCopy">
                  <span>Part-time format</span>
                  <strong>Built around your week</strong>
                </div>

                <div
                  className="trpc-studyMode__tableTicker"
                  aria-hidden="true"
                >
                  {marketCandles.slice(0, 7).map((trend, index) => (
                    <span
                      key={`table-${trend}-${index}`}
                      className="trpc-studyMode__miniCandle"
                      data-trend={trend}
                    />
                  ))}
                </div>
              </div>

              <ul
                className="trpc-studyMode__detailGrid"
                aria-label="Part-time study format"
              >
                {studyRows.map((row, index) => (
                  <StudyDetailCard row={row} index={index} key={row.id} />
                ))}
              </ul>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

export default BootcampStudyMode;
